'use client'

import { useContext, useEffect, useRef, useState } from "react";
import FloatDialog from "./_floatDialog";
import { SignContext } from "@/context/signContext";
import InqueryFooter from "../etc/inqueryFooter";
import addhomeIOS_ko from "@/public/image/etc/addHomeIOS_ko.png"
import addhomeIOS_en from "@/public/image/etc/addHomeIOS_en.png"
import addhomeChrome_ko from "@/public/image/etc/addHomeChrome_ko.png"
import addhomeChrome_en from "@/public/image/etc/addHomeChrome_en.png"
import { useLocale, useTranslations } from "next-intl";

export default function FloatAddAppIOS() {
    const { IOSPopupShow, setIOSPopupShow } = useContext(SignContext)
    const locale = useLocale();
    const [id, setId] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    const formRef = useRef<HTMLFormElement>(null)
    const idInputRef = useRef<HTMLInputElement>(null)
    const [activeTab, setActiveTab] = useState<number>(1)

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    return (
        <FloatDialog
            show={IOSPopupShow}
            setShow={setIOSPopupShow}
            className="IosPopup" >

            <FloatDialog.Head>{a("AddHome")}</FloatDialog.Head>
            <FloatDialog.Body>
                <div className={`addHomePopup`}>
                    <div className={`tab flex center`}>
                        <div onClick={() => { setActiveTab(1) }} className={activeTab === 1 ? "active" : ""}>{t('사파리')}</div>
                        <div onClick={() => { setActiveTab(2) }} className={activeTab === 2 ? "active" : ""}>{t('크롬')}</div>
                    </div>
                    <div className={`contents`}>
                        <div className={activeTab === 1 ? "show" : ""}>
                            <img src={`image/etc/addHomeIOS_${locale}.png`} />
                        </div>
                        <div className={activeTab === 2 ? "show" : ""}>
                            <img src={`image/etc/addHomeChrome_${locale}.png`} />
                        </div>
                    </div>
                </div>
            </FloatDialog.Body>
        </FloatDialog>
    )
}